import React from "react";
import "./cssservices.css";
import img0 from '../../assets/templates/img0.png'
import img1 from '../../assets/templates/img1.png'
import img2 from '../../assets/templates/img2.png'
import img3 from '../../assets/templates/img3.png'
import img4 from '../../assets/templates/img4.png'
import img5 from '../../assets/templates/img5.png'
import img6 from '../../assets/templates/img6.png'
import img7 from '../../assets/templates/img7.png' 
import img8 from '../../assets/templates/img8.png'
import img9 from '../../assets/templates/img9.png'
import img10 from '../../assets/templates/img10.png'
import img11 from '../../assets/templates/img11.png'
//import img12 from '../../assets/templates/img2.png'
import img13 from '../../assets/templates/img13.png'
import img14 from '../../assets/templates/img14.png'
import img15 from '../../assets/templates/img15.png'
import img16 from '../../assets/templates/img16.png'
import img17 from '../../assets/templates/img17.png'
import img18 from '../../assets/templates/img18.png'
import img19 from '../../assets/templates/img19.png'
import img20 from '../../assets/templates/img20.png'
import img21 from '../../assets/templates/img21.png'
import img22 from '../../assets/templates/img22.png'
import img23 from '../../assets/templates/img23.png'
//import img24 from '../../assets/templates/img2.png'
import img25 from '../../assets/templates/img25.png'
import img26 from '../../assets/templates/img26.png'
import img27 from '../../assets/templates/img27.png'
import img28 from '../../assets/templates/img28.png'
import img29 from '../../assets/templates/img29.png'           
import img30 from '../../assets/templates/img30.png'
import img31 from '../../assets/templates/img31.png'

export const services = () => {
  const data0 = [
    {
      image : img0,
      prix: '1000 XCFA',
      id: 0,
      title:'Ailes de poulet',
      description:'Des ailes de poulet cuites et assaisonnées, souvent servies avec une sauce épicée ou une trempette'
    },
    {
      image : img1,
      prix: '1750 XCFA',
      id: 1,
      title:'Salade verte',
      description: 'Une salade composée de divers légumes verts, tels que la laitue, les épinards, la roquette, accompagnée de vinaigrette ou d\'autres assaisonnements'
    },
    {
      image : img2,
      prix: '800 XCFA',
      id: 2,
      title:'Bruschetta',
      description: 'Des tranches de pain grillé garnies de tomates fraîches, d\'ail, d\'huile d\'olive et de basilic'
    },
    {
      image : img3,
      prix: '500 XCFA',
      id: 3,
      title:'Escargots',
      description: 'Des escargots cuits au beurre et à l\'ail. un plat ideal de viande "congo meat" qui peut etre accompagné avec du pain'
    },
    {
      image : img4,
      prix: '1000 XCFA',
      id: 4,
      title:'Water fufu and Eru',
      description: 'L\'eru est une sauce verte préparée à partir des feuilles de l\'eru et accompagnée de water fufu cuits'
    },
    {
      image : img5,
      prix: '850 XCFA',
      id: 5,
      title:'Koki',
      description: 'Le Koki est un plat camerounais fait à partir de haricots écrasés, géneralement consomé avec de la banane, plantain, manioc et autre'
    },
    {
      image : img6,
      prix: '400 XCFA',
      id: 6,
      title:'Pile pommes',
      description: 'Les pommes de terre pilées sont des pommes de terre cuites et pilé avec du haricot et de l\'huile de palme'
    }
  ]
  const data1 = [
    {
      image : img7,
      prix: '1000 XCFA',
      id: 7,
      title:'Steak grillé',
      description: 'Un morceau de viande de bœuf grillé selon la cuisson souhaitée, généralement servi avec des accompagnements tels que des légumes, des frites ou une purée de pommes de terre.'
    },
    {
      image : img8,
      prix: '7500 XCFA',
      id: 8,
      title:'Poulet rôti',
      description: 'Un poulet entier rôti au four, assaisonné avec des épices et des herbes, servi avec des légumes ou des pommes de terre rôties.'
    },
    {
      image : img9,
      prix: '450 XCFA',
      id: 9,
      title:'Pâtes',
      description: 'Une variété de plats de pâtes, comme les spaghetti, les fettuccine, les penne, accompagnés de différentes sauces comme la sauce tomate, la sauce à la crème, la sauce pesto ou la sauce bolognaise.'
    },
    {
      image : img10,
      prix: '500 XCFA',
      id: 10,
      title:'Risotto',
      description: 'Un plat italien à base de riz cuit lentement dans un bouillon, souvent mélangé avec des légumes, des fruits de mer ou de la viande.'
    },
    {
      image : img11,
      prix: '1300 XCFA',
      id: 12,
      title:'Burger',
      description: 'Un sandwich composé d\'un steak haché grillé ou d\'une alternative végétarienne, accompagné de garnitures telles que le fromage, les légumes, les condiments et les frites.'
    },
    {
      image : img13,
      prix: '2000 XCFA',
      id: 13,
      title:'SCurry de lentilles',
      description: 'Un plat végétarien ou végétalien à base de lentilles mijotées dans une sauce épicée, souvent servi avec du riz ou du pain.'
    }
  ]
  const data2 = [
    {
      image : img14,
      prix: '500 XCFA',
      id: 14,
      title:'Mille-feuille',
      description:'Un dessert composé de fines couches de pâte feuilletée et de crème pâtissière, souvent garni de glaçage ou de sucre en poudre.'
    },
    {
      image : img15,
      prix: '800 XCFA',
      id: 15,
      title:'Cheese-cake',
      description:'Un gâteau au fromage crémeux, cuit au four, souvent servi avec un coulis de fruits ou une garniture sucrée.'
    },
    {
      image : img16,
      prix: '1100 XCFA',
      id: 16,
      title:'Croustade aux pommes',
      description:'Un dessert à base de pommes cuites et légèrement sucrées, recouvertes d\'une couche croustillante de pâte.'
    },
    {
      image : img17,
      prix: '200 XCFA',
      id: 17,
      title:'Profiteroles',
      description:'Des petits choux garnis de crème pâtissière et généralement nappés de chocolat chaud'
    },
    {
      image : img18,
      prix: '100 XCFA',
      id: 18,
      title:'Crêpes',
      description:'Des fines crêpes garnies de diverses saveurs sucrées, telles que le sirop d\'érable, le sucre en poudre, la confiture, les fruits frais ou la crème fouettée.'
    }
  ]
  const data3 = [
    {
      image : img19,
      prix: '3500 XCFA',
      id: 19,
      title:'Plats de fruits de mer',
      description:'Des plats spéciaux mettant en avant les fruits de mer frais et de saison, tels que les plateaux de fruits de mer, les poissons entiers grillés ou les fruits de mer préparés de manière inventive.'
    },
    {
      image : img20,
      prix: '1200 XCFA',
      id: 20,
      title:'Plats végétariens ou végétaliens',
      description:'Des plats spéciaux conçus pour les clients qui suivent un régime végétarien ou végétalien, mettant en valeur les légumes, les légumineuses et les alternatives végétales.'
    }
  ]
  const data4 = [
    {
      image : img21,
      prix: '1300 XCFA',
      id: 21,
      title:'Salades',
      description:'Des salades composées avec des légumes frais, des herbes, des fruits, des noix et des vinaigrettes.'
    },
    {
      image : img22,
      prix: '800 XCFA',
      id: 22,
      title:'Ratatouille',
      description:'Un plat provençal composé d\'aubergines, de courgettes, de poivrons, d\'oignons et de tomates, mijotés ensemble avec des herbes et des épices.'
    },
    {
      image : img23,
      prix: '500 XCFA',
      id: 23,
      title:'Risotto aux champignons',
      description:'Un plat italien à base de riz cuit lentement dans un bouillon crémeux avec des champignons, du fromage et des herbes.'
    }
  ]
  const data5 = [
    {
      image : img25,
      prix: '150 XCFA',
      id: 25,
      title:'Eau',
      description:'L\'eau est une boisson de base et essentielle dans tous les restaurants. Elle peut être servie plate ou pétillante.'
    },
    {
      image : img26,
      prix: '250 XCFA',
      id: 26,
      title:'Sodas et boissons gazeuses',
      description:'Des boissons rafraîchissantes et pétillantes, telles que les sodas classiques, les limonades, les colas, les boissons aux fruits gazeuses, etc.'
    },
    {
      image : img27,
      prix: '400 XCFA',
      id: 27,
      title:'Jus de fruits',
      description:' Des jus de fruits frais pressés ou des jus de fruits en bouteille, tels que le jus d\'orange, de pomme, de raisin, de pamplemousse, etc.'
    },
    {
      image : img28,
      prix: '150 XCFA',
      id: 28,
      title:'Thé',
      description:'Une boisson chaude ou froide préparée en infusant des feuilles de thé, avec une variété de saveurs disponibles, comme le thé noir, le thé vert, le thé à la menthe, etc.'
    },
    {
      image : img29,
      prix: '600 XCFA',
      id: 29,
      title:'Cocktails',
      description:'Des boissons alcoolisées mélangées à base d\'alcools forts, de jus de fruits, de sirops et d\'autres ingrédients aromatiques. Certains cocktails populaires comprennent le Mojito, le Margarita, le Cosmopolitan, etc.'
    },
    {
      image : img30,
      prix: '6000 XCFA',
      id: 30,
      title:'Vins',
      description:'Une sélection de vins rouges, blancs et rosés, qui peuvent être proposés au verre ou à la bouteille pour accompagner les plats.'
    },
    {
      image : img31,
      prix: '10 000 XCFA', 
      id: 31,
      title:'Spiritueux',
      description:'Des boissons alcoolisées telles que le whisky, la vodka, le rhum, le gin, la tequila, etc., qui peuvent être consommées seules ou utilisées comme base pour des cocktails.'
    }
  ]
  return (
    <section id="services">
      <h5>Nos differentes categories de Menu</h5>
      <h2 id="entree">Entrées</h2>
        
        <div className="container portfolio_container">
        {
          data0.map(({id, image, title, prix, description}) =>{
            return (
              <article key={id} className="portfolio_item">
                <div className="portfolio_item_image">
                  <img src={image} alt={title} />
                </div>
                <h3> {title} </h3>
                <div>{description}</div>
                <div className="portfolio_item_cta">
                  <div className="btn">{prix}</div>
                </div>
              </article>
            )
          }
          )
        }
        </div>
        <h2 id="principaux">Plats principaux</h2>
        <div className="container portfolio_container">
        {
          data1.map(({id, image, title, prix, description}) =>{
            return (
              <article key={id} className="portfolio_item">
                <div className="portfolio_item_image">
                  <img src={image} alt={title}/>
                </div>
                <h3> {title} </h3>
                <div>{description}</div>
                <div className="portfolio_item_cta">
                  <div className="btn">{prix}</div>
                </div>
              </article>
            );
          }
          )
        }
        </div>
        <h2 id="dessert">Desserts</h2>
        <div className="container portfolio_container">
        {
          data2.map(({id, image, title, prix, description}) =>{
            return (
              <article key={id} className="portfolio_item">
                <div className="portfolio_item_image">
                  <img src={image} alt={title}/>
                </div>
                <h3> {title} </h3>
                <div>{description}</div>
                <div className="portfolio_item_cta">
                  <div className="btn">{prix}</div>
                </div>
              </article>
            );
          }
          )
        }
        </div>
        <h2 id="speciale">Plats spéciaux || occasions || événements particuliers</h2>
        
        <div className="container portfolio_container">
        {
          data3.map(({id, image, title, prix, description}) =>{
            return (
              <article key={id} className="portfolio_item">
                <div className="portfolio_item_image">
                  <img src={image} alt={title}/>
                </div>
                <h3> {title} </h3>
                <div>{description}</div>
                <div className="portfolio_item_cta">
                  <div className="btn">{prix}</div>
                </div>
              </article>
            );
          }
          )
        }
        </div>
        <h2 id="vegetale">plats végétariens</h2>
        
        <div className="container portfolio_container">
        {
          data4.map(({id, image, title, prix, description}) =>{
            return (
              <article key={id} className="portfolio_item">
                <div className="portfolio_item_image">
                  <img src={image} alt={title}/>
                </div>
                <h3> {title} </h3>
                <div>{description}</div>
                <div className="portfolio_item_cta">
                  <div className="btn">{prix}</div>
                </div>
              </article>
            );
          }
          )
        }
        </div>
        <h2 id="boisson">Boissons</h2>
        
        <div className="container portfolio_container">
        {
          data5.map(({id, image, title, prix, description}) =>{
            return (
              <article key={id} className="portfolio_item">
                <div className="portfolio_item_image">
                  <img src={image} alt={title}/>
                </div>
                <h3> {title} </h3>
                <div>{description}</div>
                <div className="portfolio_item_cta">
                  <div className="btn">{prix}</div>
                </div>
              </article>
            );
          }
          )
        }
        </div>
      </section>
    )
  };

export default services;
